var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('product'),_vm._v(" "),_c('bent'),_vm._v(" "),_c('message'),_vm._v(" "),_c('review'),_vm._v(" "),_c('blanket',{staticClass:"mt-5 import mx-auto"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e85f394","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page3/cart.vue
// module id = 645
// module chunks = 0